import React from 'react'
import AboutTeam from '../components/about-team/AboutTeam'

function AboutTeamPage() {
  return (
    <div>
      <AboutTeam />
    </div>
  )
}

export default AboutTeamPage
